import { BaseModel } from "model/BaseModel";

export default class DefeitoFabricacao implements BaseModel {
    id: number;
    codigo: string | null="";
    descricao: string;

    constructor(
        id = 0,
        descricao = ''
    ) {
        this.id = id;
        this.descricao = descricao;
    }
}